import { render, staticRenderFns } from "./HTMLContent.vue?vue&type=template&id=41bbf1e4"
import script from "./HTMLContent.vue?vue&type=script&lang=ts"
export * from "./HTMLContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports